<!-- Layouts handle the structure - this is just the entry point -->
<p-toast position="top-left" />
<router-outlet></router-outlet>